var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { AppInPopup } from ".";
import { Button } from "../Form";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
export var AppInPopupButton = function (_a) {
    var onModalClose = _a.onModalClose, children = _a.children, props = __rest(_a, ["onModalClose", "children"]);
    var _b = React.useState(false), popupShown = _b[0], setPopupShown = _b[1];
    var originalTitle = React.useRef(document.title).current;
    var t = useTranslation().t;
    var onClose = React.useCallback(function () {
        var _a;
        if (onModalClose)
            onModalClose();
        setPopupShown(false);
        (_a = window.history) === null || _a === void 0 ? void 0 : _a.replaceState(null, originalTitle, window.location.search || ".");
    }, [onModalClose, setPopupShown]);
    var onButtonPress = React.useCallback(function () {
        var scrollX = window.scrollX, scrollY = window.scrollY;
        window.location.hash = "#";
        window.scrollBy(scrollX, scrollY);
        setPopupShown(true);
    }, [setPopupShown]);
    var popupProps = __assign(__assign({}, props), { showPopup: popupShown, onModalClose: onClose, children: t("bookcart.popup_form_subtext") });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "primary", onClick: onButtonPress }, parse(props.attributes.label || t("bookcart.popup_form_button_fallback"))),
        popupShown && React.createElement(AppInPopup, __assign({}, popupProps))));
};
